// extracted by mini-css-extract-plugin
export default {"inner":"Carousel_inner__6rAhp"};